<template>
  
</template>

<script>
export default {
    name:'GameBase',
    data(){
        return {
            userInfo:undefined,
            unlockUrl:'',
        }
    },
    methods:{
        onItemClick(val) {
            // console.log(val)
            this.userInfo = this.$store.state.userInfo
            if (this.userInfo == undefined) {
                this.$alert(this.$t('LoginCommon.unloginTip'), this.$t('LoginCommon.unlogin'), {
                    confirmButtonText: this.$t('CommonObject.confirm'),
                    cancelButtonText: this.$t('CommonObject.cancel'),
                    confirmButtonClass:'confirm-button-class',
                    cancelButtonClass:'cancel-button-class',
                    type: 'warning'
                }).then(() => {
                    this.$router.push("/login");
                }).catch(() => {

                });
                return;
            }
            let statu = val.matchStatus
            switch(statu){
            case '进行中':
                this.checkSignupStatus(val,(code,m)=>{
                    if(code == 1){
                        this.gotoMatch(m)
                        
                    }else if(code == 0){
                        // 检查用户账号有效期
                        
                        if(this.checkAccountExpiration()){
                            this.signupMatch(val,(state,v)=>{
                                if(state == true){
                                    this.gotoMatch(val)
                                }
                            })
                        }else {
                            this.$alert(this.$t('LoginObject.accountExpired') + this.$t('LoginObject.accountExpirsubfix'), this.$t('CommonObject.tipTitle'), {
                                confirmButtonText: this.$t('CommonObject.ok'),
                                confirmButtonClass: 'confirm-button-class',
                                type:'error',
                                callback: action => {        
                                }
                            });
                        }
                        
                    }else {
                        // 用户取消了报名
                        // this.$toastWarning('报名取消')
                    }
                },false)
                break
            case "未开始":
                this.checkSignupStatus(val,(code,m)=>{
                    if(code == 1){
                        // this.$toastWarning('比赛尚未开始哦~')
                        this.gotoWatingPage(m)
                    }else if(code == 0){
                        this.signupMatch(val,(state,v)=>{
                            if(state == true){
                                this.$toastSuccess(this.$t('GameObject.signSuccess'))
                            }
                        })
                    }else {
                        // 用户取消了报名
                        this.$toastError(this.$t('GameObject.signFail'))
                    }
                },true)
                break;
            case "统计中":
            this.$toastWarning(this.$t('GameObject.instatistics'))
                break;
            case "完成":
            this.$alert(this.$t('GameObject.seeinaccount'), this.$t('GameObject.finish'), {
                    confirmButtonText: this.$t('CommonObject.confirm'),
                confirmButtonClass: 'confirm-button-class',
                type:'success',
                callback: action => {}
                });
                break;
            
            default:
                // console.log('val.matchStatus',val.matchStatus)
                break;
        }
            switch(statu){
                case '进行中':
                this.getsignupMathStatus(val,(sign,data)=>{
                    if(sign == 1){ // 已报名
                        this.$set(val,'mode','match')
                        this.$router.push({ name: 'PracticePage', params: val})
                    }else if(sign == 2){
                        this.signupMatch(val,(up,data)=>{
                            if(up){
                                this.$set(val,'mode','match')
                                this.$router.push({ name: 'PracticePage', params: val})
                            }
                        })
                    }
                },false)
                    break
                case "未开始":
                    
                    this.getsignupMathStatus(val,(sign,data)=>{
                        if(sign == 1){ // 已报名
                            // this.$toastWarning('比赛尚未开始哦~')
                            // 改成跳到比赛等待界面
                            this.gotoWatingPage(data)
                    }else if(sign == 2){
                        if(this.checkAccountExpiration()){
                            this.signupMatch(val,(up,data)=>{
                            if(up){
                                this.$toastSuccess(this.$t('GameObject.signSuccess'))
                            }else {
                                this.$toastError(this.$t('GameObject.signFail'))
                            }
                        })
                        }else{
                            this.$alert(this.$t('LoginObject.accountExpired') + this.$t('LoginObject.accountExpirsubfix'), this.$t('CommonObject.tipTitle'), {
                                confirmButtonText: this.$t('CommonObject.ok'),
                                confirmButtonClass: 'confirm-button-class',
                                type:'error',
                                callback: action => {        
                                }
                            });
                        }
                    }
                    },true)
                    break;
                case "统计中":
                    this.$toastWarning(this.$t('GameObject.instatistics'))
                    break;
                case "完成":
                this.$alert(this.$t('GameObject.seeinaccount'), this.$t('GameObject.finish'), {
                    confirmButtonText: this.$t('CommonObject.confirm'),
                    confirmButtonClass: 'confirm-button-class',
                    type:'success',
                    callback: action => {}
                    });
                    break;
                
                default:
                    console.log('val.matchStatus',val.matchStatus)
                    break;
            }
            
        },
        onPracticeItemClick(val) {
            this.userInfo = this.$store.state.userInfo
            if (this.userInfo == undefined) {
                this.$confirm(this.$t('LoginCommon.unloginTip'), this.$t('LoginCommon.unlogin'),{
                    confirmButtonText: this.$t('LoginObject.name'),
                    cancelButtonText: this.$t('CommonObject.cancel'),
                    confirmButtonClass:'confirm-button-class',
                    cancelButtonClass:'cancel-button-class',
                    type: 'warning'
                }).then(action => {
                    if(action == 'confirm'){
                        // this.$router.push({ name: "Login", params: { type: 'login' } }).catch(err => {
                        // })
                        // 跳转路由 替换成 弹框
                        this.$bus.$emit('OPEN_LOGIN_DIALOG')
                    }
                }).catch(() => {

                });
                return;
            }

            // console.log('val',val)
            if (val.lock == true) {
                let p =  val.costPoint
                this.$confirm(this.$t('GameObject.needPoints') +p , this.$t('GameObject.notunlock'), {
                    confirmButtonText: this.$t('GameObject.unlock'),
                    cancelButtonText: this.$t('CommonObject.cancel'),
                    confirmButtonClass:'confirm-button-class',
                    cancelButtonClass:'cancel-button-class',
                    type: 'warning'
                }).then((action) => {
                    if(action == 'confirm'){
                        this.doUnlockCourse(val)
                    }
                    
                }).catch(() => {

                });
                return
            } else {
                this.goTowhatyouWant(val)
            }

        },
        getUnlockUrl(){
            return ''
        },
        // 等待子类覆盖
        goTowhatyouWant(val){

        },
        // 等待子类覆盖
        gotoMatch(val){

        },
        checkAccountExpiration(){
            this.userInfo = this.$store.state.userInfo
            let t = this.userInfo.expirationMill
            let code = this.$timeUtils.calcExpiration(t)
            return code >= 0
        },
        // 跳到比赛等待界面
        gotoWatingPage(data){
            this.$router.push({ name: 'Wating', params: data})
        },
        signupMatch(val,callback){
            this.userInfo = this.$store.state.userInfo

            let params =  {
                matchId: val.id,
                userId: this.userInfo.id
            }
            this.$request.postnotAuthor('/match/signup',{},params,false).then(response=>{
                if(response.data.code == 200){
                    callback(true,val)
                }else {
                    this.$toastError(this.$t('GameObject.signfail'))
                    callback(false,val)
                }
            }).catch(err=>{
                // console.log('报名出错，请重试',err)
                this.$toastError(this.$t('GameObject.signfail'))
                callback(false,val)
            })
        },
        doUnlockCourse(val) {
            // console.log('解锁对象：',val)
            this.userInfo = this.$store.state.userInfo
            let body = {
                id: val.id,
                userId: this.userInfo.id
            }
            let unlockUrl = this.getUnlockUrl()
            this.$request.postUseToken(unlockUrl, {},{params:body}).then(response => {
                // console.log(response)
                if (response.data.code == 200) {
                    this.$toastSuccess(this.$t('GameObject.unlocksuccess'),)
                    //刷新列表
                    this.getPracticeDatas()
                }else if(response.data.code == 500){
                    this.$toastError(this.$t('GameObject.unlockenough'))
                } else {
                    this.$toastError(this.$t('GameObject.unlockfail'))
                }
            }).catch(err => {
                this.$toastError(this.$t('GameObject.unlockfail'))
            })
        },
        // 需要混入的组件 具体实现
        getPracticeDatas(){

        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/hanscourse/base/game_base.vue